var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 55C13.625 55 12.4483 54.5108 11.47 53.5325C10.4917 52.5542 10.0017 51.3767 10 50V25C10 23.625 10.49 22.4483 11.47 21.47C12.45 20.4917 13.6267 20.0017 15 20H17.5V15C17.5 11.5417 18.7192 8.59417 21.1575 6.1575C23.5958 3.72084 26.5433 2.50167 30 2.5C33.4567 2.49834 36.405 3.7175 38.845 6.1575C41.285 8.5975 42.5033 11.545 42.5 15V20H45C46.375 20 47.5525 20.49 48.5325 21.47C49.5125 22.45 50.0017 23.6267 50 25V50C50 51.375 49.5108 52.5525 48.5325 53.5325C47.5542 54.5125 46.3767 55.0017 45 55H15ZM30 42.5C31.375 42.5 32.5525 42.0108 33.5325 41.0325C34.5125 40.0542 35.0017 38.8767 35 37.5C34.9983 36.1233 34.5092 34.9467 33.5325 33.97C32.5558 32.9933 31.3783 32.5033 30 32.5C28.6217 32.4967 27.445 32.9867 26.47 33.97C25.495 34.9533 25.005 36.13 25 37.5C24.995 38.87 25.485 40.0475 26.47 41.0325C27.455 42.0175 28.6317 42.5067 30 42.5ZM22.5 20H37.5V15C37.5 12.9167 36.7708 11.1458 35.3125 9.6875C33.8542 8.22917 32.0833 7.5 30 7.5C27.9167 7.5 26.1458 8.22917 24.6875 9.6875C23.2292 11.1458 22.5 12.9167 22.5 15V20Z",
    fill: "url(#paint0_linear_2375_426)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2375_426",
    x1: 30,
    y1: 2.5,
    x2: 30,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.e01a1ae74d2be1667d2aa50016e8d93d.svg";
export { ForwardRef as ReactComponent };